import { FC, ReactElement } from "react";
// import { Link } from "react-router-dom";
import { CircularProgress, Typography, Box, Alert } from "@mui/material";
import { formatDistanceToNow } from "date-fns";

import {
  BodyText,
  PercentageText,
  ProgressContainer,
  StyledLinearProgress,
  StyledLoaderText,
  StyledProcessBox,
} from "../style";
import { tokens } from "@/tokens";
import { getTaskHealth } from "@/utils";

interface Props {
  title?: string;
  renderSubtitle?: () => ReactNode;
  progress?: number;
  hideLoader?: boolean;
  onClick?: () => void;
  task?: TradeDataLogsTypes;
}

const ProcessBox: FC<Props> = ({
  title = "Processing Data",
  renderSubtitle,
  progress = 0,
  hideLoader = false,
  task,
}): ReactElement => {
  const taskHealthInfo = task ? getTaskHealth(task) : null;
  return (
    <StyledProcessBox>
      <StyledLoaderText>
        <>
          <svg width={0} height={0}>
            <defs>
              <linearGradient
                id="my_gradient"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="10%" stopColor="#052223" />
                <stop offset="50%" stopColor="#052223" />
                <stop offset="100%" stopColor="#0b494b5e" />
              </linearGradient>
            </defs>
          </svg>
          {!hideLoader && (
            <CircularProgress
              style={{ width: "16px", height: "16px" }}
              sx={{
                "svg circle": { stroke: "url(#my_gradient)" },
              }}
            />
          )}
        </>
        <Typography
          variant="h5"
          sx={{
            marginLeft: !hideLoader ? "15px" : 0,
            fontSize: "1.25rem",
            color: tokens.brand.primary,
          }}
        >
          {title}
        </Typography>
      </StyledLoaderText>

      <BodyText variant="body2" color="textSecondary">
        {renderSubtitle
          ? renderSubtitle()
          : "Data processing will take time, please don't close the window."}
        {/* Check logs from{" "}
        <span onClick={onClick}>
          <Link to="#">here</Link>.
        </span> */}
      </BodyText>

      {/* Heartbeat Status Information */}
      {task && task.lastHeartbeat && (
        <Box sx={{ marginTop: 1, marginBottom: 1 }}>
          <Typography variant="caption" color="textSecondary">
            Last activity: {formatDistanceToNow(new Date(task.lastHeartbeat))} ago
          </Typography>
        </Box>
      )}

      {/* Health Status Warnings */}
      {taskHealthInfo && taskHealthInfo.health !== 'healthy' && (
        <Box sx={{ marginTop: 1, marginBottom: 1 }}>
          <Alert 
            severity={taskHealthInfo.health === 'stale' ? 'warning' : 'error'}
            sx={{ fontSize: tokens.fontSize.lg }}
          >
            {taskHealthInfo.message}
          </Alert>
        </Box>
      )}

      <ProgressContainer>
        <StyledLinearProgress variant="determinate" value={progress} />
        <PercentageText variant="body2">{progress}%</PercentageText>
      </ProgressContainer>
    </StyledProcessBox>
  );
};

export default ProcessBox;
